const n = (r) => r && typeof r == "string" ? r : r && typeof r == "object" ? t(r) : "", t = (r) => {
  let e = [];
  return r && typeof r == "object" ? ((r.name_preferred || r.name) && e.push(r.name_preferred || r.name), r.place_formatted && e.push(r.place_formatted), e.join(", ")) : "";
};
export {
  t as generateFriendlyName,
  n as getValue
};
//# sourceMappingURL=LocationPicker.utils.es.js.map
